// extracted by mini-css-extract-plugin
export default {"component":"FeeSelector_component__++-JD","option":"FeeSelector_option__jGERH","selected":"FeeSelector_selected__Sbek+"};